<template>
  <div class="block">
    <form @submit="addEvent" autocomplete="off">
      <table style="width: 70%; margin-left: auto; margin-right: auto;">
        <tr>
          <div>
          <td ><label for="name_in"> Event Name </label></td>
          <td><input autocomplete="off" type="text" v-model="name_in" id="name_in" name="name_in" placeholder="Event name..."/></td>
          </div>
      </tr>
      <hr style="border: dashed 2px; border-style: none none dashed;" />
      <tr>
        <div>
          <td><label for="start_year">Start Year </label></td>
          <td><input autocomplete="off" type="text" v-model="start_year" id="start_year" name="start_year" placeholder="Year"/></td>
        </div>
      </tr>
      <tr>
        <div>
          <td><label for="start_month">Month</label></td>
          <td><select v-model="start_month" id="start_month" name="start_month">
            <option disabled value="">Month</option>
            <option value="0">January</option>
            <option value="1">February</option>
            <option value="2">March</option>
            <option value="3">April</option>
            <option value="4">May</option>
            <option value="5">June</option>
            <option value="6">July</option>
            <option value="7">August</option>
            <option value="8">September</option>
            <option value="9">October</option>
            <option value="10">November</option>
            <option value="11">December</option>
          </select></td>

        </div>
      </tr>
      <tr>
        <div>
          <td><label for="start_day">Day</label></td>
          <td><input  autocomplete="off" type="text" v-model="start_day" id="start_day" name="start_day" placeholder="Day"/></td>
        </div>
        </tr>
        <hr style="border: dashed 2px; border-style: none none dashed;" />
        <tr>
          <div>
          <td style="text-align: left"><label for="end_year"> End Year </label></td>
          <td ><input autocomplete="off" type="text" v-model="end_year" id="end_year" name="end_year" placeholder="Year"/></td>
          </div>
         </tr>
         <tr>
            <div>
              <td style="text-align: left"><label for="end_month">Month </label></td>
              <td style="text-align: left"><select v-model="end_month" id="end_month" name="end_month">
              <option disabled value="">Month</option>
              <option value="0">January</option>
              <option value="1">February</option>
              <option value="2">March</option>
              <option value="3">April</option>
              <option value="4">May</option>
              <option value="5">June</option>
              <option value="6">July</option>
              <option value="7">August</option>
              <option value="8">September</option>
              <option value="9">October</option>
              <option value="10">November</option>
              <option value="11">December</option>
            </select></td>

            </div>
          </tr>
          <tr>
            <div>
            <td style="text-align: left"><label for="end_day">Day </label></td>
            <td><input autocomplete="off" type="text" v-model="end_day" id="end_day" name="end_day" placeholder="Day"/></td>
          </div>
          </tr>
          <hr style="border: dashed 2px; border-style: none none dashed;" />
          <tr>
            <div>
              <td style="text-align: left;"><label for="dt_in">Duration Type </label></td>
              <td style="text-align: left;"><select v-model="dt_in" id="dt_in" name="dt_in">
                <option disabled value="">Duration Type</option>
                <option value="0">Day</option>
                <option value="1">Month</option>
                <option value="2">Year</option>
              </select></td>

            </div>
          </tr>
          <tr>
            <div>
              <td style="text-align: left;"><label for="dn_in">Duration </label></td>
              <td style="text-align: left;"><input type="text" v-model="dn_in" id="dn_in" name="dn_in" placeholder="Duration Number"/></td>
            </div>
        </tr>
        <hr style="border: dashed 2px; border-style: none none dashed;" />
        <tr>
          <div v-for="(field, index) in field_names" v-bind:key="field">
              <div>
                <td><label :for="field">{{field}}</label></td>
                <td><input autocomplete="off" type="text" v-model="extra_fields[index]" :id="field" :name="field" :placeholder="field"/></td>
              </div>
          </div>
        </tr>
      <input type="submit" value="Add Event" class="button"/>
      </table>
    </form>
  </div>
</template>

<script>
import uuid from 'uuid/v4'

export default {
  name: 'AddEventBlock',
  props: ["field_names"],
  data() {
    return {
      name_in: '',
      start_year: '',
      start_month: '',
      start_day: '',
      end_year: '',
      end_month: '',
      end_day: '',
      dn_in: '',
      dt_in: '',
      extra_fields: this.field_names.map(() => '')
    }
  },
  methods: {
    addEvent(event) {
      event.preventDefault();

      if ((!this.start_year || (!this.end_year && (!this.dn_in || !this.dt_in))) || !this.name_in) {
        alert("Every event needs to have a start date, an end date or duration, and a name.");
        this.$emit('error-alert', JSON.stringify({error: "Create Event: Every event needs to have a start date, an end date or duration, and a name.", event_data: {name: this.name_in, start_year: this.start_year, end_year: this.end_year, duration_number: this.dn_in, duration_type: this.dt_in}}));
      } else {
        if (isNaN(this.start_year) || (this.start_month && isNaN(this.start_month)) || (this.start_day && isNaN(this.start_day))
        || (this.end_year && isNaN(this.end_year)) || (this.end_month && isNaN(this.end_month))
        || (this.end_day && isNaN(this.end_day)) || (this.dn_in && isNaN(this.dn_in))) {
          alert("All dates need to be a number!");
          this.$emit('error-alert', JSON.stringify({error: "Create Event: All dates need to be a number!", event_data: {name: this.name_in, start_year: this.start_year, start_month: this.start_month, start_day: this.start_day, end_year: this.end_year, end_month: this.end_month, end_day: this.end_day, duration_number: this.dn_in}}));
        } else {
          if (!this.start_month) {
            this.start_month = 0;
          }

          if (!this.start_day) {
            this.start_day = 1;
          }

          let startDate = new Date(this.start_year, this.start_month, this.start_day);
          let durationT = null;
          let durationN = null;
          let endDate = null;

          if (this.dt_in && this.dn_in) {
            durationT = this.dt_in;
            durationN = parseInt(this.dn_in);

            if (durationT == 0) {
              let days = durationN;
              if ((durationN - 1) >= 0) {
                days = durationN - 1;
              }

              endDate = new Date(this.start_year, this.start_month, (parseInt(this.start_day) + days));
            }

            if (durationT == 1) {
              endDate = new Date(this.start_year, (parseInt(this.start_month) + durationN), this.start_day);
            }

            if (durationT == 2) {
              endDate = new Date((parseInt(this.start_year) + durationN), this.start_month, this.start_day);
            }
          } else {
            if (!this.end_month) {
              this.end_month = 0;
            }

            if (!this.end_day) {
              this.end_day = 1;
            }

            endDate = new Date(this.end_year, this.end_month, this.end_day);
          }

          const newEventBlock={
            name: this.name_in,
            startDate: startDate,
            endDate: endDate,
            id: uuid(),
            durationNumber: durationN,
            durationType: durationT,
            extra_fields: this.extra_fields
          }

          if (newEventBlock.endDate < newEventBlock.startDate) {
            alert("An event's end date has to happen after its start date!");
            this.$emit('error-alert', JSON.stringify({error: "Create Event: An event's end date has to happen after its start date!", event_data: {name: this.name_in, start_year: this.start_year, start_month: this.start_month, start_day: this.start_day, end_year: this.end_year, end_month: this.end_month, end_day: this.end_day, duration_number: this.dn_in}}));
          } else {
            this.$emit('add-event', newEventBlock);
            this.name_in = '';
            this.start_year = '';
            this.start_month = '';
            this.start_day = '';
            this.end_year = '';
            this.end_month = '';
            this.end_day = '';
            this.dn_in = '';
            this.dt_in = '';
            this.extra_fields = this.field_names.map(() => '');
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.block {
  display: block;
  background-color: var(--form-blue);
  color: rgb(245, 239, 239);
  padding: 0.5rem;
  width: 100%;
  min-width: 300px;

}

.line {
  padding: 0.2rem;
}

.item {
  padding-left: 0.2rem;
  padding-right: 0.2rem;
}

.button {
  background-color: var(--block-orange);
  font-family: system-ui, sans-serif;
  font-weight: 500;
  border-radius: 2px;
  margin-top: 10px;
}

.button:hover{
  cursor: pointer;
}

label{
    display: inline-block;
    width: 120px;
    text-align: left;
    font-weight: bold;
}


input {
  display: inline-block;
  position: relative;
  border-radius: 2px;
  border-width:0px;
  border:none;
}


input::placeholder{
  font-style: italic;
}

input[type='text'] {
  font-family: sans-serif;
  font-weight: 500;
}

label[for="start_month"]{
  text-align: left;
}

select[id="start_month"]{
  position: left;
}



</style>
